// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__d7NUB","main":"styles_main__53Z_s"};